import { useRecoilValue, useSetRecoilState } from "recoil";
import { loginState } from "../../stores/loginState";
import { useMutation } from "react-query";
import { LogenInstance } from "../instance";
import { barcodeTrackingState } from "../../stores/barcode/barcodeTrackingState";

// TODO 운송장 화물추적 정보 조회 API
export const useGetTracking = (trackingValue) => {
  // NOTE 상태 변수 선언
  const login = useRecoilValue(loginState); // 로그인 전역변수
  const setTracking = useSetRecoilState(barcodeTrackingState); // 화물추적 데이터

  // TODO API 통신 Mutation
  return useMutation(
    async () => {
      if (login.company === "LOGEN") {
        // API 리퀘스트 정보
        const response = await LogenInstance.post("/tracking", {
          api: "info",
          data: [
            {
              barcode: trackingValue,
            },
          ],
        });
        return response.data; // Assuming `data` is the payload you need
      } else {
        throw new Error("Invalid company");
      }
    },
    {
      // 성공 시
      onSuccess: (data) => {
        setTracking(data);
      },
      // 실패 시
      onError: (error) => {
        console.log(error);
      },
    }
  );
};
